module.exports = __webpack_public_path__ + "img/zh.b9bf89f1.png";